import React from 'react'
import Button from './Button'
import HostLink from './HostLink'
import { usePublicSignup } from '../publicConfig'

/**
 * The marketing "Start free trial" call-to-action, in one place so every
 * surface (Home/Pricing/FAQ/About/nav/footer) stays consistent with the
 * PUBLIC_SIGNUP_ENABLED flag.
 *
 * When public signup is open: a link → /signup styled as a Button. A HostLink,
 * because /signup is on the app host and these CTAs are on the marketing one.
 * During the private beta (flag off): a disabled-styled "Private beta — invite
 * only" button plus a small "Want in? Email hello@praenum.com" mailto, so an
 * interested visitor is captured with zero new backend. Sign In is unaffected
 * (handled by the nav/footer, not this component).
 *
 * Props mirror Button's `variant`/`size`/`className`; `label` overrides the
 * open-state button text; `mailto` toggles the "Want in?" line (default on).
 */
export default function SignupCTA({
  label = 'Start free trial',
  variant = 'primary',
  size = 'md',
  className = '',
  fullWidth = false,
  mailto = true,
}) {
  const publicSignup = usePublicSignup()
  const width = fullWidth ? 'w-full' : ''

  if (publicSignup) {
    return (
      <HostLink to="/signup" className={fullWidth ? 'block w-full' : 'inline-block'}>
        <Button variant={variant} size={size} className={`${width} ${className}`}>
          {label}
        </Button>
      </HostLink>
    )
  }

  return (
    <div className={fullWidth ? 'w-full' : 'inline-flex flex-col items-center'}>
      <Button
        variant="secondary"
        size={size}
        disabled
        className={`${width} ${className} cursor-not-allowed`}
        title="Praenum is in private beta"
      >
        Private beta, invite only
      </Button>
      {mailto && (
        <p className="text-xs text-gray-500 mt-2 text-center">
          Want in?{' '}
          <a href="mailto:hello@praenum.com" className="text-brand-500 hover:underline">
            Email hello@praenum.com
          </a>
        </p>
      )}
    </div>
  )
}
